import {Injectable} from '@angular/core';
import {SecureApi} from '../../../../core/secure.api';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class DynamicReportService {
    constructor(
        public secureApi: SecureApi,
        public translateService: TranslateService
    ) {
    }

    url = 'b2c-patients/dynamic-report'

    getAll(filters) {
        let queryParams = filters;
        return this.secureApi.get(this.url + '/index?' + queryParams);
    }

    getCluster(clusteruid, filters) {
        let queryParams = filters;

        let language = this.translateService.currentLang.split('_')[0];
        queryParams += '&lang=' + language;
        return this.secureApi.get(this.url + '/active-cluster/' + clusteruid + '?' + queryParams);
    }

    getSubCluster(clusteruid, subClusterUid, filters) {
        let queryParams = filters;
        return this.secureApi.get(this.url + '/active-sub-cluster/' + clusteruid + '/' + subClusterUid + '?' + queryParams);
    }
}
